module.exports = __webpack_public_path__ + "cc1b6c982302a40d546f304c377bb24c.png";